import React from "react";
import { Link } from "react-router-dom";
import Meta from "../components/Meta";
import "./AccessDeniedScreen.css";

export default function AccessDeniedScreen() {
  return (
    <main className="access-denied-screen">
      <Meta title="Access Denied | Academy Costumes London" />

      <span className="access-denied-screen__code" aria-hidden="true">
        403
      </span>

      <h1 className="access-denied-screen__title">Access Denied</h1>

      <p className="access-denied-screen__text">
        You do not have the required permissions to access this admin area.
      </p>

      <div className="access-denied-screen__links">
        <Link to="/admin" className="access-denied-screen__link">
          Go to Dashboard
        </Link>
        <Link to="/" className="access-denied-screen__link access-denied-screen__link--secondary">
          Back to store
        </Link>
      </div>
    </main>
  );
}
